import config from '@/config'

export default {
	id: 'SIMPLE_IN_APP_1M_29_99_1M_13_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_ios_1m_29_99_1m_13_99_usd',
		},
		primer: 'prd_PCkV58cUn56Y',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 13.99,
		},
		originalPriceMap: {
			USD: 29.99,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
		},
	},
}
